import { tuple } from './type';
export var PresetStatusColorTypes = tuple('success', 'processing', 'error', 'default', 'warning'); // eslint-disable-next-line import/prefer-default-export

export var PresetColorTypes = tuple('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/_util/colors.js
// module id = 2533
// module chunks = 0